export const VALUE_OTHER = 'other';

export const isOtherMultiToggleItem = (valueItem: string) => valueItem === VALUE_OTHER;
export const isNotOtherMultiToggleItem = (valueItem: string) => valueItem !== VALUE_OTHER;
